"use client";
import { useEffect, useMemo, useRef } from "react";
//#region packages/@mantine/hooks/src/utils/use-callback-ref/use-callback-ref.ts
function useCallbackRef(callback) {
	const callbackRef = useRef(callback);
	useEffect(() => {
		callbackRef.current = callback;
	});
	return useMemo(() => ((...args) => callbackRef.current?.(...args)), []);
}
//#endregion
export { useCallbackRef };

//# sourceMappingURL=use-callback-ref.mjs.map